import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueViewer from 'v-viewer'


Vue.config.productionTip = false
Vue.use(VueViewer)
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
